module.exports = __webpack_public_path__ + "sound-indicator.svg?ac4bf8d6da75b7d3ead2cd950e381d20";